(function () {
  var wrxRoot = document.getElementById('wrx');
  var WRX_PANEL_INVENTORY = parseInt(wrxRoot.dataset.wrxPanelInventory, 10) || 0;
  var panelInStock = WRX_PANEL_INVENTORY > 0;

  var overlay = document.getElementById('wrxModalOverlay');
  var checkbox = document.getElementById('wrxTermsCheck');
  var goBtn = document.getElementById('wrxModalGo');
  var backBtn = document.getElementById('wrxModalBack');
  var pendingCheckoutUrl = null;
  var lastFocused = null;

  function openModal(checkoutUrl) {
    pendingCheckoutUrl = checkoutUrl;
    checkbox.checked = false;
    goBtn.disabled = true;
    lastFocused = document.activeElement;
    overlay.classList.add('wrx-open');
    checkbox.focus();
  }
  function closeModal() {
    overlay.classList.remove('wrx-open');
    pendingCheckoutUrl = null;
    if (lastFocused) lastFocused.focus();
  }
  checkbox.addEventListener('change', function () { goBtn.disabled = !checkbox.checked; });
  goBtn.addEventListener('click', function () { if (checkbox.checked && pendingCheckoutUrl) window.location.href = pendingCheckoutUrl; });
  backBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('wrx-open')) closeModal(); });

  if (panelInStock) {
    var panelItem = document.getElementById('wrxPanelItem');
    panelItem.classList.add('wrx-instock');
    document.getElementById('wrxPanelPill').outerHTML =
      '<span class="wrx-pill-green">In stock &middot; Only ' + WRX_PANEL_INVENTORY + ' left &middot; Ships right away</span>';
    document.getElementById('wrxUltStrip').textContent = 'Only ' + WRX_PANEL_INVENTORY + ' Panels Left \u00b7 Ships Right Away';
    document.getElementById('wrxUltStrip').className = 'wrx-prestrip wrx-prestrip--navy';
    document.getElementById('wrxStandNote').textContent = '(ships now with your panel)';
    document.getElementById('wrxShipNote').innerHTML = '<strong>Your panel &amp; stand ship right away.</strong><br>Your original order is unchanged.';
    document.getElementById('wrxHeaderSub').innerHTML = 'If you saw the Ultimate Kit was sold out and wanted to get your hands on the WeRestore Panel, this is your chance. We found ' + WRX_PANEL_INVENTORY + ' panels in our final inventory count, and we\u2019re offering them to our Complete buyers first. Upgrade your order to the full Ultimate Kit at the same launch pricing, and <strong>keep every dollar of your launch savings.</strong>';
  }
  document.getElementById('wrxUpgradeBtn').addEventListener('click', function () {
    var url = this.getAttribute('data-wrx-checkout');
    if (panelInStock) { window.location.href = url; } else { openModal(url); }
  });
})();
